"use client";

import { ReactNode } from "react";

import HeaderHome from "@/components/HeaderHome";
import { Footer } from "@/components/Footer";
import { BlackFridayBanner } from "@/components/BlackFridayBanner";
import { BlackFridayIntro } from "@/components/BlackFridayIntro";
import { promotions } from "@/config/promotions";

interface LandingChromeProps {
  children: ReactNode;
}

export function LandingChrome({ children }: LandingChromeProps) {
  const showBlackFridayPromo = promotions.blackFridayEnabled;

  return (
    <>
      {showBlackFridayPromo && <BlackFridayIntro />}
      {showBlackFridayPromo && <BlackFridayBanner />}
      <HeaderHome />
      <main className="mx-auto mb-20 min-h-screen w-full max-w-6xl px-4 sm:px-6 lg:px-8">
        {children}
      </main>
      <Footer />
    </>
  );
}
